import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as tenants from '../../../tenants'
import type { Feature } from '../feature'

/** Loads the Tenant audiences that Platform Admin users can manage. */
export const executeLoadTenants = store.effects.create(
  (feature: Feature, api: tenants.Api) =>
    feature.actions.loadTenants.request.observe().pipe(
      rxjs.exhaustMap(action =>
        api.list(undefined).pipe(
          rxjs.map(response =>
            feature.actions.loadTenants.success.from(action).create({
              request: action.data,
              response,
            }),
          ),
          rxjs.catchError(error =>
            rxjs.of(
              feature.actions.loadTenants.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
